import React from 'react';

const WizardProgress = ({ step, stepCount }) => {
    const items = [];

    for (let i = 0; i < stepCount; i++) {
        const isCompleted = i + 1 < step;
        const isActive = step == i + 1;
        const className = isCompleted ? 'completed' : isActive ? 'active' : '';

        items.push(
            <li key={i} className={`wizard-step ${className}`}>
                <span className="step-number">{isCompleted ? '✓' : i + 1}</span>
                <span className="step-label">Step {i + 1}</span>
            </li>
        );

        if (i < stepCount - 1) {
            items.push(
                <li key={`line-${i}`} className={`wizard-line ${isCompleted ? 'completed' : ''}`} aria-hidden="true" />
            );
        }
    }

    return <ul className="wizard-progress">{items}</ul>;
};

export default WizardProgress;
